'use strict'

import store from './ConfigStore.js'

import ConfigClass from './js/ConfigClass.js'

class ConfigModel extends ConfigClass {

  setStore () {
    this.store = store
  }

  setVariables () {
    super.setVariables()
  }
}

export { ConfigModel, store }
export default ConfigModel
